// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2SncR","fileBtn":"File_fileBtn__20KKv","closeBtn":"File_closeBtn__3W1gD","fileSelected":"File_fileSelected__31Zav","disabled":"File_disabled__3pBhQ"};